module.exports = __webpack_public_path__ + "img/Icon_Contestacion_Remedio_Provicional.675d17c7.svg";